export const CRASHLYTICS_AUTH_ERROR = 'CL_AUTH_ERROR';
export const CRASHLYTICS_GENERATE_OTP_ERROR = 'CL_GENERATE_OTP_ERROR';
export const CRASHLYTICS_LOGOUT_ERROR = 'CL_LOGOUT_ERROR';
export const CRASHLYTICS_VERIFY_OTP_ERROR = 'CL_VERIFY_OTP_ERROR';
export const CRASHLYTICS_APP_ERROR = 'CL_APP_ERROR';
export const CRASHLYTICS_PROFILE_ERROR = 'CL_PROFILE_ERROR';
export const CRASHLYTICS_DOCUMENT_UPLOAD_ERROR = 'CL_DOCUMENT_UPLOAD_ERROR';
export const CRASHLYTICS_API_ERROR = 'CL_API_ERROR';

export const ErrorCodes = {
  INSUFFICIENT_DATA: '400_1_1',
};
